import { Injectable } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

/**
 * Определяет, открыта ли страница в "бизнес" режиме (query-параметр isBusiness=true).
 * Используется несколькими страницами для переключения оформления
 * (фон, наличие общего хэдера, вид полей формы и т.д.), поэтому вынесено в отдельный сервис.
 */
@Injectable({
  providedIn: 'root'
})
export class BusinessModeService {
  private mobile = false;

  constructor(breakpointObserver: BreakpointObserver) {
    breakpointObserver.observe([Breakpoints.Handset, Breakpoints.XSmall, Breakpoints.Small]).subscribe(result => {
      this.mobile = result.matches;
    });
  }

  get isBusiness(): boolean {
    // window.location, а не router.url/router.parseUrl — у Router.url есть
    // задержка: при первом заходе по прямой ссылке (особенно в lazy-loaded
    // модуль, см. contract.module.ts) он остаётся на '/' ДО ТЕХ ПОР, пока
    // чанк не скачается и навигация не завершится, а это может занимать
    // ощутимое время на мобильной сети. Всё это время isBusiness ложно
    // считался false — из-за этого мелькал общий <app-header> (см.
    // app.component.html/isBusinessMobile) с шапкой и навигацией поверх
    // страниц устава/учредительных документов, хотя адресная строка уже
    // содержала ?isBusiness=true с самого начала. window.location.search
    // отражает реальный текущий URL сразу, без этой задержки.
    return new URLSearchParams(window.location.search).get('isBusiness') === 'true';
  }

  get isMobile(): boolean {
    return this.mobile;
  }

  // Бизнес-оформление действует только на мобильной версии
  get isBusinessMobile(): boolean {
    return this.isBusiness && this.mobile;
  }
}
